<template>
  <ReassuranceItem
    v-if="shouldDisplayVerifiedRefurbishedCampaign"
    :show-icon-background="false"
  >
    <template #icon>
      <RevIllustration
        alt=""
        :height="40"
        src="/img/product/verified-refurbished/logo-with-bg.svg"
        :width="40"
      />
    </template>
    <template #content>
      <span>
        <RevLink
          class="body-2-bold text-left underline"
          @click="deployVerifiedRefurbishedModal"
        >
          {{ i18n(translations.verified) }}
        </RevLink>
      </span>
      <VerifiedRefurbishedModal />
    </template>
  </ReassuranceItem>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '~/scopes/product/constants'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'
import VerifiedRefurbishedModal from '../VerifiedRefurbishedModal/VerifiedRefurbishedModal.vue'

import translations from './ItemVerifiedRefurbished.translations'

const SMARTPHONE_CATEGORY = 2

const props = defineProps<{
  productCategory: number
}>()

const i18n = useI18n()

const shouldDisplayVerifiedRefurbishedCampaign = computed(() => {
  return props.productCategory === SMARTPHONE_CATEGORY
})

function deployVerifiedRefurbishedModal() {
  openModal(MODAL_NAMES.VERIFIED_REFURBISHED)
}
</script>
